import { render, staticRenderFns } from "./saved-vacancies.vue?vue&type=template&id=d2510c28&"
import script from "./saved-vacancies.vue?vue&type=script&lang=js&"
export * from "./saved-vacancies.vue?vue&type=script&lang=js&"
import style0 from "./saved-vacancies.vue?vue&type=style&index=0&id=d2510c28&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports